import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import './ProductsPages.css';
import ProductsPnHeader from '../../components/ProductsPnHeader';
import TitleAndContentCard from '../../components/TitleAndContentCard';
import ExpandableCard from '../../components/ExpandableCard';
import CheckCircle from '../../icons/CheckCircle';
import { useTranslation } from 'react-i18next';
import WhyChooseOurPms from '../../components/WhyChooseOurPms';
import useLanguagePrefix from '../../LanguagePrefix';

function ProstayNexus() {
    const { t } = useTranslation();
    const langPrefix = useLanguagePrefix();
    const features = [
        { title: t('Keep Every Conversation in One Place'), content: t('No more switching between apps. Emails, WhatsApp messages, and guest replies all live inside your PMS.') },
        { title: t('Messaging That Understands Your Operations'), content: t('Built for hotel teams, Nexus links every message to a reservation—so your replies are always informed and on point.') },
        { title: t('Automate the Essentials, Personalize the Rest'), content: t('From confirmations to reminders, Nexus handles routine communication so your team can focus on personal touches.') },
        { title: t('Real-Time Collaboration Across Teams'), content: t('Assign, tag, and track conversations across departments, all while maintaining clarity and accountability.') },
    ];

    const roomPlanningExpandableCards = [
        { title: t("Centralized Dashboard"), content: t("Manage reservations, availability, and guest data in one place.") },
        { title: t("Housekeeping & Task Management"), content: t("Manage reservations, availability, and guest data in one place.") },
        { title: t("Channel Manager"), content: t("Manage reservations, availability, and guest data in one place.") },
    ];
    const [selectedTabIndex, setSelectedTabIndex] = useState(0);
    const [activeIndex, setActiveIndex] = useState(0);

    const handleActiveIndex = (index) => {
        setActiveIndex(index);
    }

    return (
        <div>
            <Helmet>
                <title>Prostay – Guest Messaging & Communication Platform</title>
                <meta name="description" content="Prostay Nexus connects email, WhatsApp & guest messaging in one platform—automated, synced with reservations, and built for hotel teams." />
                 <link rel="canonical" href={"https://www.prostay.com/products/prostay-nexus"} /> 


                 <meta property="og:title" content="Prostay – Guest Messaging & Communication Platform" />
                <meta property="og:description" content="Prostay Nexus connects email, WhatsApp & guest messaging in one platform—automated, synced with reservations, and built for hotel teams." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://www.prostay.com/products/prostay-nexus" />
                <meta property="og:image" content='https://prostay.com/images/ogImage.png' />

                <meta property="og:site_name" content="Prostay" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Prostay – Guest Messaging & Communication Platform" />
                <meta name="twitter:description" content="Prostay Nexus connects email, WhatsApp & guest messaging in one platform—automated, synced with reservations, and built for hotel teams." />
                <meta name="twitter:image" content='https://prostay.com/images/ogImage.png' />
                <meta name="twitter:site" content="@prostaypms" />
                <meta name="twitter:creator" content="@prostaypms" />


            </Helmet>
            <div className='product-page'>
                <ProductsPnHeader />
                <div className='d-flex justify-content-center product-page-content'>
                    <div className='page-content'>
                        <div className='d-flex justify-content-between py-2 py-md-5' style={{ flexWrap: 'wrap' }}>
                            <div className='col-12 col-md-5'>
                                <h2>{t('Everything You Need to Keep the Conversation Flowing')}</h2>
                            </div>
                            <div className='col-12 col-md-5'>
                                <p className='body-large'>
                                    {t('Integrated directly with your Prostay PMS, every message is tied to a reservation, making follow-ups, context, and service delivery more seamless than ever.')}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='d-flex features-carousel-wrapper'>
                    <div className='d-flex gap-3 features-carousel pb-5'>
                        {
                            features.map((feature, index) =>
                                <TitleAndContentCard title={feature.title} content={feature.content} width={384} height={178} onClick={() => handleActiveIndex(index)} />
                            )
                        }
                    </div>
                </div>
                <div className='d-flex justify-content-center py-2 py-md-5' style={{ flexWrap: 'wrap' }}>
                    <div className='page-content d-flex justify-content-between gap-4'>
                        <div className='col-12 col-md-4'>
                            <div className={selectedTabIndex == 0 ? 'tab-btn focused' : 'tab-btn'} onClick={() => setSelectedTabIndex(0)}>
                                <label className='label-medium'>  {t('Unified Inbox')} </label>
                                {
                                    selectedTabIndex == 0 &&
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14 5L21 12M21 12L14 19M21 12H3" stroke="#1643E0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                }
                            </div>
                            <div className={selectedTabIndex == 1 ? 'tab-btn focused' : 'tab-btn'} onClick={() => setSelectedTabIndex(1)}>
                                <label className='label-medium'>  {t('Built-In Knowledge Base')} </label>
                                {
                                    selectedTabIndex == 1 &&
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14 5L21 12M21 12L14 19M21 12H3" stroke="#1643E0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                }
                            </div>
                            <div className={selectedTabIndex == 2 ? 'tab-btn focused' : 'tab-btn'} onClick={() => setSelectedTabIndex(2)}>
                                <label className='label-medium'>  {t('Activity Log')} </label>
                                {
                                    selectedTabIndex == 2 &&
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14 5L21 12M21 12L14 19M21 12H3" stroke="#1643E0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                }
                            </div>
                            <div className={selectedTabIndex == 3 ? 'tab-btn focused' : 'tab-btn'} onClick={() => setSelectedTabIndex(3)}>
                                <label className='label-medium'>  {t('Reservation-Linked Messaging')} </label>
                                {
                                    selectedTabIndex == 3 &&
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14 5L21 12M21 12L14 19M21 12H3" stroke="#1643E0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                }
                            </div>
                            <div className={selectedTabIndex == 4 ? 'tab-btn focused' : 'tab-btn'} onClick={() => setSelectedTabIndex(4)}>
                                <label className='label-medium'>  {t('Multi-User Collaboration')} </label>
                                {
                                    selectedTabIndex == 4 &&
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14 5L21 12M21 12L14 19M21 12H3" stroke="#1643E0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                }
                            </div>
                            <div className={selectedTabIndex == 5 ? 'tab-btn focused' : 'tab-btn'} onClick={() => setSelectedTabIndex(5)}>
                                <label className='label-medium'>  {t('Full Email Client Functionality')} </label>
                                {
                                    selectedTabIndex == 5 &&
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14 5L21 12M21 12L14 19M21 12H3" stroke="#1643E0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                }
                            </div>
                        </div>
                        <div className='col tab-content'>
                            {
                                selectedTabIndex == 0 &&
                                <>
                                    <h4>{t('All Guest Messages, One Place')}</h4>
                                    <img src='/images/nexus-room-planning.png' alt={"Room planning"} />
                                    <p>
                                        {t('Prostay Nexus unifies your guest communication into a single, clean inbox. Emails, WhatsApp messages, and integrated third-party channel messages, all appear in one streamlined interface, fully connected to the guest’s reservation in your PMS. No more switching between email clients, WhatsApp web, or mobile phones—your team gets everything in one place, with filters, tags, and search tools to make high-volume communication effortless.')}
                                    </p>
                                    <p>
                                        {t('Messages are grouped by guest and linked to their stay details, making it easy to respond with full context. It’s ideal for busy reservations departments that need to maintain professionalism, speed, and clarity at scale.')}
                                    </p>
                                    <h5 className='my-4'>{t('Room Planning')}</h5>
                                    <div className='d-flex align-items-center gap-2'>
                                        <CheckCircle />
                                        <p style={{ margin: 0, fontWeight: 600 }}>Centralized email & WhatsApp communication</p>
                                    </div>
                                    <div className='d-flex align-items-center gap-2 mt-3'>
                                        <CheckCircle />
                                        <p style={{ margin: 0, fontWeight: 600 }}>Messages grouped by reservation & guest</p>
                                    </div>
                                    <div className='d-flex align-items-center gap-2 mt-3'>
                                        <CheckCircle />
                                        <p style={{ margin: 0, fontWeight: 600 }}>Works across multi-property setups</p>
                                    </div>
                                    <div className='d-flex align-items-center gap-2 mt-3'>
                                        <CheckCircle />
                                        <p style={{ margin: 0, fontWeight: 600 }}>Saves time and reduces manual tracking</p>
                                    </div>
                                </>
                            }
                            {
                                selectedTabIndex == 1 &&
                                <>
                                    <h4>{t('Built-In Knowledge Base - Answers at Your Fingertips')}</h4>
                                    {/*<img src='/images/room-planning.png' alt={"Room planning"} /> */}
                                    <p>
                                        {t('Prostay Nexus features a built-in Knowledge Base designed to support your reservations and front office teams in real time. Staff can search and access pre-written answers, SOPs, policy information, and service details directly within the messaging interface—without leaving the guest conversation.')}
                                    </p>
                                    <p>
                                        {t('Whether it’s check-in instructions, cancellation policies, upgrade options, or local recommendations, your team will have instant access to consistent, accurate information that improves response time and service quality.')}
                                    </p>
                                    <p>
                                        {t('The Knowledge Base is fully customizable and can be updated as your property evolves—ensuring your team always has the right answers.')}
                                    </p>
                                    <h5 className='my-4'>{t('Room Planning')}</h5>
                                    <div className='d-flex align-items-center gap-2'>
                                        <CheckCircle />
                                        <p style={{ margin: 0, fontWeight: 600 }}>Internal support built into the messaging platform</p>
                                    </div>
                                    <div className='d-flex align-items-center gap-2 mt-3'>
                                        <CheckCircle />
                                        <p style={{ margin: 0, fontWeight: 600 }}>Quick access to policies, FAQs, and SOPs</p>
                                    </div>
                                    <div className='d-flex align-items-center gap-2 mt-3'>
                                        <CheckCircle />
                                        <p style={{ margin: 0, fontWeight: 600 }}>Searchable and categorized for fast lookup</p>
                                    </div>
                                    <div className='d-flex align-items-center gap-2 mt-3'>
                                        <CheckCircle />
                                        <p style={{ margin: 0, fontWeight: 600 }}>Reduce response times and training effort</p>
                                    </div>
                                </>
                            }
                            {
                                selectedTabIndex == 2 &&
                                <>
                                    <h4>{t('Activity Log - Transparency in Every Interaction')}</h4>
                                    {/*   <img src='/images/room-planning.png' alt={"Room planning"} /> */}
                                    <p>
                                        {t('Prostay Nexus includes a detailed Activity Log that tracks every action taken within a conversation—who responded, when they replied, what was edited, and how the conversation progressed. This ensures total visibility and accountability across your reservations and communications team.')}
                                    </p>
                                    <p>
                                        {t('Whether you need to audit a guest interaction, review a missed message, or understand team performance, the Activity Log gives you a clear and chronological view of all actions taken. It’s especially useful in multi-user environments or when multiple departments are involved in guest service.')}
                                    </p>
                                    <h5 className='my-4'>{t('Room Planning')}</h5>
                                    <div className='d-flex align-items-center gap-2'>
                                        <CheckCircle />
                                        <p style={{ margin: 0, fontWeight: 600 }}>Tracks all actions in a conversation thread</p>
                                    </div>
                                    <div className='d-flex align-items-center gap-2 mt-3'>
                                        <CheckCircle />
                                        <p style={{ margin: 0, fontWeight: 600 }}>View edits, replies, notes, and assignments</p>
                                    </div>
                                    <div className='d-flex align-items-center gap-2 mt-3'>
                                        <CheckCircle />
                                        <p style={{ margin: 0, fontWeight: 600 }}>Maintain accountability across the team</p>
                                    </div>
                                    <div className='d-flex align-items-center gap-2 mt-3'>
                                        <CheckCircle />
                                        <p style={{ margin: 0, fontWeight: 600 }}>Helpful for audits, reviews, and conflict resolution</p>
                                    </div>
                                </>
                            }
                            {
                                selectedTabIndex == 3 &&
                                <>
                                    <h4>{t('Reservation-Linked Messaging')}</h4>
                                    {/*   <img src='/images/room-planning.png' alt={"Room planning"} /> */}
                                    <p>
                                        {t('Every conversation in Nexus is directly connected to a guest’s reservation. View check-in/out dates, room type, payment status, and special notes right alongside the message thread—so you can respond with confidence, accuracy, and personalization.')}
                                    </p>
                                    <p>
                                        {t('Need to switch rooms, adjust a reservation, or note a VIP arrival? You can do it directly from the message view. Nexus eliminates the need to flip between systems or look up files—the guest record is already there, linked and live.')}
                                    </p>
                                    <h5 className='my-4'>{t('Room Planning')}</h5>
                                    <div className='d-flex align-items-center gap-2'>
                                        <CheckCircle />
                                        <p style={{ margin: 0, fontWeight: 600 }}>View reservation details next to every message</p>
                                    </div>
                                    <div className='d-flex align-items-center gap-2 mt-3'>
                                        <CheckCircle />
                                        <p style={{ margin: 0, fontWeight: 600 }}>Modify bookings directly from the inbox (with permissions)</p>
                                    </div>
                                    <div className='d-flex align-items-center gap-2 mt-3'>
                                        <CheckCircle />
                                        <p style={{ margin: 0, fontWeight: 600 }}>Reduce errors and improve reply accuracy</p>
                                    </div>
                                    <div className='d-flex align-items-center gap-2 mt-3'>
                                        <CheckCircle />
                                        <p style={{ margin: 0, fontWeight: 600 }}>Deliver truly personalized communication</p>
                                    </div>
                                </>
                            }
                            {
                                selectedTabIndex == 4 &&
                                <>
                                    <h4>{t('Multi-User Collaboration')}</h4>
                                    {/*   <img src='/images/room-planning.png' alt={"Room planning"} /> */}
                                    <p>
                                        {t('Nexus is built for collaboration. Multiple team members can view, reply to, assign, or leave internal notes on guest conversations—all with full visibility. Conversations can be tagged by department, flagged for follow-up, or reassigned to ensure nothing slips through the cracks.')}
                                    </p>
                                    <p>
                                        {t('You can also set visibility levels, track message ownership, and leave operational notes on specific reservations—all within the communication thread. Whether you have two agents or twenty, Nexus keeps everyone aligned.')}
                                    </p>
                                    <h5 className='my-4'>{t('Room Planning')}</h5>
                                    <div className='d-flex align-items-center gap-2'>
                                        <CheckCircle />
                                        <p style={{ margin: 0, fontWeight: 600 }}>Multi-user inbox with conversation ownership</p>
                                    </div>
                                    <div className='d-flex align-items-center gap-2 mt-3'>
                                        <CheckCircle />
                                        <p style={{ margin: 0, fontWeight: 600 }}>Internal notes for team handoffs</p>
                                    </div>
                                    <div className='d-flex align-items-center gap-2 mt-3'>
                                        <CheckCircle />
                                        <p style={{ margin: 0, fontWeight: 600 }}>Assign and reassign messages by department</p>
                                    </div>
                                    <div className='d-flex align-items-center gap-2 mt-3'>
                                        <CheckCircle />
                                        <p style={{ margin: 0, fontWeight: 600 }}>Tag by urgency, guest type, or request</p>
                                    </div>
                                </>
                            }
                            {
                                selectedTabIndex == 5 &&
                                <>
                                    <h4>{t('Full Email Client Functionality')}</h4>
                                    {/*   <img src='/images/room-planning.png' alt={"Room planning"} /> */}
                                    <p>
                                        {t('Prostay Nexus isn’t just a messaging add-on—it functions as a fully capable email client designed specifically for hotel operations. Connect your reservations or front office email accounts (e.g., info@yourhotel.com or reservations@yourhotel.com) directly to Nexus and manage all incoming and outgoing messages without needing Gmail, Outlook, or third-party platforms.')}
                                    </p>
                                    <p>
                                        {t('All emails are threaded, searchable, and linked to reservations where applicable. Staff can reply, forward, CC, and attach documents just like in a traditional inbox, but with the added context of guest data and automation tools built in. This ensures your communication is fast, organized, and always connected to your operations.')}
                                    </p>
                                    <h5 className='my-4'>{t('Room Planning')}</h5>
                                    <div className='d-flex align-items-center gap-2'>
                                        <CheckCircle />
                                        <p style={{ margin: 0, fontWeight: 600 }}>Native support for hotel email accounts (IMAP/SMTP)</p>
                                    </div>
                                    <div className='d-flex align-items-center gap-2 mt-3'>
                                        <CheckCircle />
                                        <p style={{ margin: 0, fontWeight: 600 }}>Send, receive, reply, forward, and attach files</p>
                                    </div>
                                    <div className='d-flex align-items-center gap-2 mt-3'>
                                        <CheckCircle />
                                        <p style={{ margin: 0, fontWeight: 600 }}>Link emails directly to reservations and guest profiles</p>
                                    </div>
                                    <div className='d-flex align-items-center gap-2 mt-3'>
                                        <CheckCircle />
                                        <p style={{ margin: 0, fontWeight: 600 }}>Searchable message history across all inboxes</p>
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                </div>
                <div className='d-flex justify-content-center mt-5 d-none d-md-flex'>
                    <div className='page-content d-flex w-100 justify-content-center align-items-center' style={{ textAlign: "center" }}>
                        <div className='col-lg-6 d-flex flex-column align-items-center'>
                            <h2 style={{ textAlign: "center", maxWidth: '582px' }}>{t('Revolutionize your business with our PMS Platform')}</h2>
                            <p className='body-large' style={{ textAlign: "center", maxWidth: '582px' }}>
                                {t('Cutting-edge Property Management System designed to revolutionize the way hotels, and resorts from boutique to large-scale, operate and serve their guests.')}
                            </p>
                        </div>
                    </div>
                </div>
                <div className='d-flex justify-content-center bottom-padding'>
                    <div className='page-content '>
                        <div className='white-card p-3 p-md-5 d-flex justify-content-between mt-3 mt-lg-5 gap-4 gap-lg-1' style={{ flexWrap: "wrap" }}>
                            <div className='col-12 col-lg-5'>
                                <h4>{t('Turn Conversations Into Guest Satisfaction')}</h4>
                                <p className='mt-4'>
                                    {t('See how Prostay Nexus brings clarity, consistency, and speed to guest communication—fully integrated with your PMS and ready to scale with your team.')}
                                </p>
                                <a href={` /request-demo`} style={{ textDecoration: 'none' }}><button className='light-blue-filled-btn-small mt-5'>
                                    {t('Request Demo')}
                                    <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M13 5.99992H1Z" fill="white" />
                                        <path d="M8.33333 1.33325L13 5.99992M13 5.99992L8.33333 10.6666M13 5.99992H1" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </button></a>
                            </div>
                            <div className='col-12 col-lg-6'>
                                <img src='/images/nexusdetails.png' style={{ maxWidth: "100%" }} alt={"Room planning"} />
                            </div>
                        </div>
                    </div>
                </div>
                <WhyChooseOurPms
                    headerTitle="Take Control of your Business Today!"
                    headerDescription="Cutting-edge Property Management System designed to revolutionize the way hotels, and resorts from boutique to large-scale, operate and serve their guests."
                    sectionTitle="Why Choose Our Messaging Platform?"
                    sectionDescription="From how it integrates with your PMS to what channels are supported and how automation works, this section is designed to give you clarity and confidence before getting started."
                    cards={[
                        { title: "What channels does Prostay Nexus support?", description: "Currently, Prostay Nexus supports email and WhatsApp integrations. SMS and additional channels are planned in future updates." },
                        { title: "Do I need a separate system to use Nexus?", description: "No. Nexus is fully built into the Prostay platform and works directly with your PMS and reservations module." },
                        { title: "Can Nexus messages be automated?", description: "Yes. You can automate confirmations, reminders, and upsells using templates and pre-set rules." },
                        { title: "Can I see past messages linked to a reservation?", description: "Yes. Every message is stored and displayed in the guest timeline, giving you complete historical context at a glance." },

                    ]}
                />
            </div>
        </div>
    );
}

export default ProstayNexus;
